import { useQuery } from 'react-query';
import { api } from '../services/api';

const basePath = 'driver';

export interface IDriver {
  id?: number;
  name: string;
  cpf: string;
  birth_date: Date | undefined;
  email: string;
  telephone: string;
  cep: string;
  state: string | undefined;
  neighborhood: string;
  street: string;
  number: string;
  complement?: string;
  number_cnh: string | null;
  validate_cnh: Date | undefined;
  emission: string;
  father_name: string;
  mother_name: string;
  rg: string;
  category: string | null;
  userVehicle?: {
    nickname: string;
    id: number;
  };
}

interface IGetDrivers {
  results: IDriver[];
  nPages: number;
  total: number;
  resultsPerPage: string;
  currentPage: string;
}

export interface IGetDriverParams {
  text?: string;
  resultsPerPage?: number;
  page?: number;
  orderBy?: string;
  orderByDirection?: string;
}

export interface ISendInvite {
  email: string;
  sub: string;
}

export interface ILinkDriver {
  idUserVehicle: number;
  idDriver: number;
  sub: string;
}

export interface IMultipleDelete {
  removeIds: number[];
}

export const getDrivers = async (
  params: IGetDriverParams,
): Promise<IGetDrivers> => {
  const { data } = await api.get(basePath, { params });
  return data.driver;
};

export function useDriverInfo(params: IGetDriverParams) {
  params.orderByDirection = params.orderByDirection?.toUpperCase();
  const queryKey = [
    basePath,
    params.orderByDirection,
    params.orderBy,
    params.text,
    params.page,
    params.resultsPerPage,
  ];

  return useQuery(queryKey, () => getDrivers(params), {
    staleTime: 60000,
  });
}

export const postDriver = async (driver: IDriver): Promise<void> => {
  await api.post(`/${basePath}`, driver);
};

export const putDriver = async (driver: IDriver): Promise<void> => {
  return await api.put(`/${basePath}`, driver);
};

export const getDriverById = async (id: number): Promise<IDriver> => {
  const { data } = await api.get(`/${basePath}/${id}`);
  return data.response as IDriver;
};

export const deleteDriver = async (id: number): Promise<any> => {
  const data = await api.delete(`/${basePath}/${id}`);
  return data;
};

export const sendInviteDriver = async (data: ISendInvite): Promise<void> => {
  return await api.post(`/${basePath}/invite?sub=${data.sub}`, {
    email: data.email,
  });
};

export const linkVehicleDriver = async (data: ILinkDriver): Promise<void> => {
  return await api.post(`/${basePath}/link-vehicle`, data);
};

export const deleteMultipleDriver = async (
  data: IMultipleDelete,
): Promise<any> => {
  return await api.put(`/${basePath}/delete-multiple`, data);
};
